const SALE_STATUS_ACTIVE = "open";
const SALE_STATUS_SOLD = "sold";
const SALE_STATUSES = [SALE_STATUS_ACTIVE, SALE_STATUS_SOLD];

export const getGASaleStatus = saleStatus => {
  if (!SALE_STATUSES.includes(saleStatus)) {
    return console.error(`Unknown status for GA Tracking: ${saleStatus}`);
  }

  if (saleStatus === SALE_STATUS_ACTIVE) {
    return "active";
  }

  return "sold";
};

export function dispatchAccessFromHDPEvent() {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "sales_show",
      event_action: "seller_dashboard",
      event_label: "click"
    });
  }
}

export function dispatchClickOnSimilarHomeEvent(listingId, listingStatus) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "seller_dashboard",
      event_action: "similar_homes",
      event_label: `click|listing_id=${listingId}|listing_status=${getGASaleStatus(
        listingStatus
      )}`
    });
  }
}

export function dispatchImpressionEvent(section) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "seller_dashboard",
      event_action: "impression",
      event_label: section
    });
  }
}

const handleListingCheckboxStatus = isChecked =>
  isChecked ? "sold" : "active";

export const sendDurationFilterGAEvent = (isChecked, period) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "seller_dashboard",
      event_action: "listing_activity",
      event_label: `select|on_market_period=past_${period}_days|compare_with=${handleListingCheckboxStatus(
        isChecked
      )}`
    });
  }
};
